
import * as kenticoRuntime$cZOSCn2Rmx from '/home/vsts/work/1/s/providers/kentico-img-provider.ts'
import * as avatarRuntime$mL6v8Eoe4l from '/home/vsts/work/1/s/providers/avatar-img-provider.ts'
import * as ipxRuntime$aeVaWKwKsX from '/home/vsts/work/1/s/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {}
}

imageOptions.providers = {
  ['kentico']: { provider: kenticoRuntime$cZOSCn2Rmx, defaults: undefined },
  ['avatar']: { provider: avatarRuntime$mL6v8Eoe4l, defaults: undefined },
  ['ipx']: { provider: ipxRuntime$aeVaWKwKsX, defaults: undefined }
}
        